import React from "react";
import {
    ButtonProps,
    ButtonRenderProps,
    ClearFiltersButton,
    ContentSection,
    DetailsRowProps,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    RenderFunction,
    SearchBox,
    Stack,
    Theme,
    ensure
} from "sprint-common-web";

import { AddEncodeSpecificationMpeg1Button } from "./buttons/AddEncodeSpecificationMpeg1Button";
import { AddEncodeSpecificationMpeg4Button } from "./buttons/AddEncodeSpecificationMpeg4Button";
import { createEncodeSpecificationListingColumns } from "./createEncodeSpecificationListingColumns";
import { EncodeSpecificationListingItem } from "./EncodeSpecificationListingItem";
import { useEncodeSpecificationListing } from "./useEncodeSpecificationListing";
import { useEncodeSpecificationListingFilters } from "./useEncodeSpecificationListingFilters";

export const EncodeSpecificationListing: React.FC = () => {
    const { filters, setName, setPage, setPageSize, clearFilters, setSort } = useEncodeSpecificationListingFilters();

    const { totalItems, isLoading, listingItems } = useEncodeSpecificationListing(filters);

    const columns = createEncodeSpecificationListingColumns();

    const addEncodeSpecificationMpeg4ButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddEncodeSpecificationMpeg4Button
    };

    const addEncodeSpecificationMpeg1ButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddEncodeSpecificationMpeg1Button
    };

    return (
        <ContentSection
            header={"Encode Specifications"}
            buttons={[addEncodeSpecificationMpeg1ButtonProps, addEncodeSpecificationMpeg4ButtonProps]}
        >
            <Grid>
                <GridRow>
                    <GridColumn sm={4}>
                        <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                    </GridColumn>

                    <GridColumn sm={8}>
                        <Stack horizontalAlign="end">
                            <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                        </Stack>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={listingItems}
                            pagination={{
                                page: filters.page,
                                pageSize: filters.pageSize,
                                totalItems,
                                onPageChange: setPage,
                                onPageSizeChange: setPageSize
                            }}
                            onRenderRow={renderRow}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                            onSortChange={setSort}
                            isLoading={isLoading}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};

const renderRow = (rowProps?: DetailsRowProps, defaultRender?: RenderFunction<DetailsRowProps>) => {
    ensure(rowProps);
    ensure(defaultRender);

    const item = rowProps.item as EncodeSpecificationListingItem;
    const testProps = {
        "data-testid": "table-row",
        "data-testkey": rowProps.item.id
    };

    return item.isModified
        ? renderModifiedRow(rowProps, defaultRender)
        : defaultRender({ ...testProps, ...rowProps }, defaultRender);
};

const renderModifiedRow = (
    rowProps: DetailsRowProps,
    defaultRender: RenderFunction<DetailsRowProps>
): JSX.Element | null =>
    defaultRender({
        ...rowProps,
        styles: {
            root: {
                borderLeft: `4px solid ${Theme.palette.blue}`
            }
        }
    });
